import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    // 监听下拉菜单（controller 元素本身）的 class 变化
    this.observer = new MutationObserver(() => {
      this.updateActiveState()
    })

    // 开始观察下拉菜单的 class 属性变化
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ["class"]
    })

    // 初始化状态
    this.updateActiveState()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  updateActiveState() {
    if (!this.hasLinkTarget) {
      return
    }

    const isHidden = this.element.classList.contains("hidden")

    if (!isHidden) {
      // 菜单展开时，添加激活样式
      this.linkTarget.classList.add("bg-[#031824]", "text-white")
    } else {
      // 菜单收起时，移除激活样式
      this.linkTarget.classList.remove("bg-[#031824]", "text-white")
    }
  }
}

